import NewEntityButton from "./NewEntityButton";

## Basic Usage

<NewEntityButton entityName="Project" onClick={() => alert("Create new project")} />

---

## Different Entity Names

<div style={{ display: "flex", flexDirection: "column", gap: "1rem", alignItems: "flex-start" }}>
  <NewEntityButton entityName="Project" onClick={() => {}} />
  <NewEntityButton entityName="Document" onClick={() => {}} />
  <NewEntityButton entityName="Team" onClick={() => {}} />
  <NewEntityButton entityName="Report" onClick={() => {}} />
</div>

---

## With Link URL

<NewEntityButton entityName="Item" linkUrl="#new-item" />

---

## Disabled State

<div style={{ display: "flex", flexDirection: "column", gap: "1rem", alignItems: "flex-start" }}>
  <NewEntityButton entityName="Project" disabled onClick={() => {}} />
  <NewEntityButton
    entityName="Document"
    disabled
    disabledTooltipText="You don't have permission to create documents"
    onClick={() => {}}
  />
</div>

Hover over the second button to see the disabled tooltip.

---

## In a Page Header

<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "1rem", borderBottom: "1px solid #e5e5e5" }}>
  <h2 style={{ margin: 0 }}>Projects</h2>
  <NewEntityButton entityName="Project" onClick={() => alert("Create project")} />
</div>

---

## In an Empty State

<div style={{ border: "1px dashed #ccc", borderRadius: "8px", padding: "3rem", textAlign: "center" }}>
  <p style={{ color: "#666", marginBottom: "1rem" }}>No documents yet</p>
  <NewEntityButton entityName="Document" onClick={() => alert("Create document")} />
</div>

